














































import { Component, Vue } from 'vue-property-decorator'

import { getArvioitavanKokonaisuudenKategoria } from '@/api/tekninen-paakayttaja'
import ElsaButton from '@/components/button/button.vue'
import ArvioitavanKokonaisuudenKategoriaForm from '@/forms/arvioitavan-kokonaisuuden-kategoria-form.vue'
import { ArvioitavanKokonaisuudenKategoriaWithErikoisala } from '@/types'
import { toastFail } from '@/utils/toast'

@Component({
  components: {
    ArvioitavanKokonaisuudenKategoriaForm,
    ElsaButton
  }
})
export default class ArvioitavanKokonaisuudenKategoriaView extends Vue {
  kategoria: ArvioitavanKokonaisuudenKategoriaWithErikoisala | null = null

  loading = true

  get items() {
    return [
      {
        text: this.$t('etusivu'),
        to: { name: 'etusivu' }
      },
      {
        text: this.$t('opetussuunnitelmat'),
        to: { name: 'opetussuunnitelmat' }
      },
      {
        text: this.kategoria?.erikoisala.nimi,
        to: { name: 'erikoisala' }
      },
      {
        text: this.$t('kategoria'),
        active: true
      }
    ]
  }

  async mounted() {
    await this.fetchKategoria()
    this.loading = false
  }

  async fetchKategoria() {
    try {
      this.kategoria = (
        await getArvioitavanKokonaisuudenKategoria(this.$route?.params?.kategoriaId)
      ).data
    } catch (err) {
      toastFail(this, this.$t('arvioitavan-kokonaisuuden-kategorian-hakeminen-epaonnistui'))
      this.$router.replace({ name: 'erikoisala', hash: '#arvioitavat-kokonaisuudet' })
    }
  }
}
